import { Component, OnInit, Pipe, PipeTransform, ViewEncapsulation, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActionControl, buttonTypes, componentName, ComponentTypes, DEFAULT_LANGUAGE_ID } from 'src/app/shared/constants/commonenums';
import { ButtonValue } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { NewPartyDetailsDTO, PartyPrepaymentState, PartyState, RegisterReservationAttemptResponseDTO, ReservationDTO } from 'src/app/shared/Models/PartyModels';
import { OperationResultState } from 'src/app/shared/Models/ResultModels';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { LayoutService } from '../layout.service';
import { ReservationService } from '../reservation.service';
import _ from 'lodash';
import { DatePipe } from '@angular/common';
import { PopupService } from 'src/app/shared/services/popup.service';
import { CoverTypePriceDTO, CoverTypeQuantitiesDTO, operationType, SpecialMealDTO } from 'src/app/shared/Models/WidgetSettingsModels';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { GuestService } from 'src/app/shared/services/guest.service';
import { FormatSettingsDatePipe } from '../../shared/pipes/format-settings-date.pipe'
import { ActivatedRoute } from '@angular/router';
import { PopupComponent } from 'src/app/shared/components/popup/popup.component';

@Component({
    selector: 'app-confirmation-details',
    templateUrl: './confirmation-details.component.html',
    styleUrls: ['./confirmation-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmationDetailsComponent extends Utilities implements OnInit, OnDestroy, AfterViewInit {
  cancelBtn: ButtonValue;
  additionalGuestBtn: ButtonValue;
  bookNewReservation: ButtonValue;
  modifyBtn: ButtonValue;
  partyDetails: any;
  guestDetails: any;
  partyConfirmationDetails: NewPartyDetailsDTO;
  cancelDialogRef: MatDialogRef<any>;
  paymentData: RegisterReservationAttemptResponseDTO;
  disclaimerPresent: false;
  subscriptions: Subscription = new Subscription();
  confirmationCode = '';
  bookingReferenceId = '';
  ratePlanAmount: number;
  specialMealAmount: number;
  noShowFeeAmount: number;
  totalAmount: number;
  taxAmount: number;
  partySize: number;
  reservationFor: string;
  environment = environment;
  reservationCancelled = false;
  seatingTypeName: string;
  specialMealName: string;
  selectedMeal: SpecialMealDTO;
  showImage = true;
  isConfirmationMsgHTML = false;
  taxes:any =[];
  showTaxDetails = false;
  serviceCharge: number;
  serviceChargeTax: number;
  subTotal: number;
  displayModifyButton : boolean = true;
  displayCancelButton : boolean = true;
  constructor(public rs: ReservationService, private ps: PopupService, public dialog: MatDialog, public ls: LayoutService, private datePipe: DatePipe, private ts: TranslateService, public gs: GuestService , public dateFormat: FormatSettingsDatePipe , public route: ActivatedRoute,) {
    super(dialog);
  }

  ngOnInit(): void {
    this.getBookingActions();
    this.createActionButton();
    this.partyDetails = _.cloneDeep(this.rs.reservationFormGroup.controls.reservationDetailsForm.value);
    this.partyConfirmationDetails = this.rs.reservationConfimationDetails;
    if (this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationMessage) {
      let ConfirmationMsg = this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationMessage;
      this.isConfirmationMsgHTML = this.isHTML(ConfirmationMsg);
    }
    if (this.rs.additionalGuestRequired > 0 && !this.rs.additionalGuestPage) {
      this.rs.additionalGuestPage = true;
    }
    this.paymentData = this.rs.reservationAttemptInfo;

    this.setReservationData();
    //Removed SEAProduction condition for #31642
    // this.showImage = environment.SEAProduction && environment.restaurantIds.filter(x => x == this.ls.restaurantWidgetSettings$.value.RestaurantId).length > 0;
    this.showImage = environment.restaurantIds.filter(x => x == this.ls.restaurantWidgetSettings$.value.RestaurantId).length > 0;


  }

  isHTML(str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }

  setReservationData() {
    if (this.ls.editPartyData$.value) {
      this.rs.primaryContact = _.cloneDeep(this.ls.editPartyData$.value.Contact);
      this.rs.secondaryContactList = this.ls.editPartyData$.value.BookingContacts && this.ls.editPartyData$.value.BookingContacts.length > 0 ? _.cloneDeep(this.ls.editPartyData$.value.BookingContacts.filter(bc=>bc.ContactId != this.ls.editPartyData$.value.Contact.Id)) : null;
      this.confirmationCode = this.ls.editPartyData$.value.ConfirmationCode;
      this.bookingReferenceId = this.ls.editPartyData$.value.BookingReferenceId;
      this.partySize = this.ls.editPartyData$.value.Size;
      this.reservationFor = this.ls.editPartyData$.value.ReservedFor.toString();
      this.setSelectedSeatingType();
      this.setSelectedSpecialMeal();
      this.taxes = this.ls.editPartyData$.value.TaxAmount;
      if (this.ls.editPartyData$.value.PrepaymentState != PartyPrepaymentState.Refunded) {
        if ((this.ls.editPartyData$.value.RatePlanAmount > 0 || this.ls.editPartyData$.value.SpecialMealAmount > 0) && (this.ls.editPartyData$.value.PrepaymentState != PartyPrepaymentState.None)) {
          this.ratePlanAmount = this.ls.editPartyData$.value.RatePlanAmount;
          this.specialMealAmount = this.ls.editPartyData$.value.SpecialMealAmount;
          this.taxAmount = this.ls.editPartyData$.value.TaxAmount;
          this.serviceCharge = this.ls.editPartyData$.value.TotalServiceChargeAmount;
          this.serviceChargeTax = this.ls.editPartyData$.value.TaxOnServiceChargeAmount;
          this.totalAmount = this.ls.editPartyData$.value.SpecialMealAmount > 0 || this.ls.editPartyData$.value.RatePlanAmount > 0 ? ((this.ls.editPartyData$.value.RatePlanAmount || 0) + (this.ls.editPartyData$.value.SpecialMealAmount || 0) + Number(this.taxAmount || 0) + Number(this.serviceCharge || 0) + Number(this.serviceChargeTax || 0)) : this.totalAmount;
          this.subTotal = Number(this.totalAmount || 0) - (Number(this.taxAmount || 0) + Number(this.serviceCharge || 0) + Number(this.serviceChargeTax || 0));
        }
        else if (this.ls.editPartyData$.value.PrepaymentState == PartyPrepaymentState.None && this.ls.editPartyData$.value.NoShowFeeAmount > 0) {
          this.noShowFeeAmount = this.totalAmount = this.subTotal = this.ls.editPartyData$.value.NoShowFeeAmount;
        }
      }
      if (this.ls.editPartyData$.value.State === PartyState.Cancelled) {
        this.rs.reservationConfirmationText = 'reservationCancellationConfirmationText'
        this.reservationCancelled = true;
      }
      else {
        if (this.ls.operation == operationType.cancel) {
          this.rs.reservationConfirmationText = 'reservationConfirmationText';
          this.cancelReservation(operationType.cancel);
        }
      }
    }
  }

  setSelectedSpecialMeal() {
    if (this.ls.editPartyData$.value.SpecialMealAmount > 0) {
      this.specialMealName = this.ls.editPartyData$.value.SpecialMealId > 0
        && this.ls.restaurantWidgetSettings$.value.AvailableSpecialMeals.findIndex(x => x.Id == this.ls.editPartyData$.value.SeatingTypeId) > -1 ?
        this.ls.restaurantWidgetSettings$.value.AvailableSpecialMeals.filter(x => x.Id == this.ls.editPartyData$.value.SpecialMealId)[0].Name :
        this.ls.editPartyData$.value.SpecialMeal && this.ls.editPartyData$.value.SpecialMeal.Name ?
          this.ls.editPartyData$.value.SpecialMeal.Name : this.ls.editPartyData$.value.SpecialMealName ?
            this.ls.editPartyData$.value.SpecialMealName : this.ts.instant('specialMeal');


      if (this.ls.editPartyData$.value.SpecialMealId > 0 && this.ls.editPartyData$.value.CoverTypeQuantities && this.ls.editPartyData$.value.CoverTypeQuantities.length > 0) {
        this.selectedMeal = this.ls.restaurantWidgetSettings$.value.AvailableSpecialMeals.filter(meal => meal.Id == this.ls.editPartyData$.value.SpecialMealId)[0];
      }
    }

  }

  setSelectedSeatingType() {
    this.seatingTypeName = this.ls.editPartyData$.value.SeatingTypeId > 0
      && this.ls.restaurantWidgetSettings$.value.SeatingTypeList.findIndex(x => x.Id == this.ls.editPartyData$.value.SeatingTypeId) > -1 ?
      this.ls.restaurantWidgetSettings$.value.SeatingTypeList.filter(x => x.Id == this.ls.editPartyData$.value.SeatingTypeId)[0].Description : this.ts.instant('seatingTypePrice')
  }

  getBookingActions(){
    this.displayModifyButton = this.ls.restaurantWidgetSettings$.value?.WidgetCustomization?.DisplayModifyButton;
    this.displayCancelButton = this.ls.restaurantWidgetSettings$.value?.WidgetCustomization?.DisplayCancelButton;
    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        if(params?.actionControl !== null && params?.actionControl !== undefined) {
          this.displayModifyButton = Number(params.actionControl) == ActionControl.CanModify || Number(params.actionControl) == ActionControl.CanModifyAndCancel;
          this.displayCancelButton = Number(params.actionControl) == ActionControl.CanCancel || Number(params.actionControl) == ActionControl.CanModifyAndCancel;
        }
      })
  }

  createActionButton() {
    if(this.displayCancelButton){
      this.cancelBtn = {
        type: buttonTypes.cancelBtn,
        label: 'cancel',
        customclass: 'reservation-confirmation__cancel-reservation',
      };
    }
    this.additionalGuestBtn = {
      type: buttonTypes.cancelBtn,
      label: 'guestDetails',
      customclass: 'reservation-confirmation__additional-guest',
      icon: 'icon-add'
    };
    if(this.displayModifyButton){
      this.modifyBtn = {
        type: buttonTypes.confirmBtn,
        label: 'modify',
        customclass: 'reservation-confirmation__modify-details',
      };
    }
    this.bookNewReservation = {
      type: buttonTypes.cancelBtn,
      label: 'bookAnotherReservation',
      customclass: 'reservation-confirmation__new-reservation',
    };
  }
  ngAfterViewInit() {
    this.subscriptions.add(this.ps.actionEnabled$.subscribe(x => {
      if (x == ComponentTypes.cancelReservation) {
        this.cancelDialogRef?.close();
        this.confirmCancelation();
      }
      else if(x == ComponentTypes.cancellationChargeInfo) {
        this.cancelDialogRef?.close();
        this.confirmCancelReservation();
      }
    }));

    this.subscriptions.add(this.ps.cancelEnabled$.subscribe(x => {
      if (x == ComponentTypes.cancelReservation) {
        this.ls.operation = operationType.edit;
        this.rs.reservationConfirmationText = 'reservationDetainedConfirmationText';
      }
    }));
  }

  modifyReservation(eve) {

    if (this.ls.editPartyData$.value) {
      this.resetPage(operationType.edit, this.ls.editPartyData$.value);
    }
    else {
      this.ls.getByToken(this.ls.reservationToken).subscribe(data => {
        if (data) {
          this.resetPage(operationType.edit, data);
        }
      });
    }
  }

  cancelReservation(eve) {
    const datePipeString = this.dateFormat.transform(new Date(this.ls.editPartyData$.value.ReservedFor) , this.ls.restaurantWidgetSettings$.value.DateFormat);
    this.ts.get('AskCancelReservationConfirmation', { date: datePipeString, locationName: this.ls.restaurantWidgetSettings$.value.RestaurantName }).subscribe(text => {
      const popUpMessage = [{
        confirmationMessage: text,
        dialogTitle: this.ts.instant('reservationCancelTitle'),
        showAlert: true
      }];
      const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
        popUpMessage[0].dialogTitle);
      this.cancelDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.cancelReservation, '450px', '300px', true, '', this.ts.instant('Yes'),
        this.ts.instant('No'), true)
    })
  }

  confirmCancelation() {
    this.gs.getCancellationCharge(this.ls.restaurantWidgetSettings$.value.RestaurantId,this.ls.editPartyData$.value.Id,[]).subscribe(data => {
      if (data && data.Payload && data.Payload.CancellationCharge > 0) {
        let cancellationCharges = data.Payload.CancellationCharge ? data.Payload.CancellationCharge : 0.00;
        let cancellationMessage = '';
        this.ts.get('cancellationFeeInfoMessage', { cancellationcharge: this.ls.restaurantWidgetSettings$.value.OperationCurrency + cancellationCharges, collectTypeInfo: '' }).subscribe(result => {
          cancellationMessage = result ? result : this.ts.instant('cancellationFeeInfoMessage') + this.ls.restaurantWidgetSettings$.value.OperationCurrency + cancellationCharges + this.ts.instant('doYouWishToProceed');
        });
        const popUpMessage = [{
          confirmationMessage: cancellationMessage,
          dialogTitle: this.ts.instant('Cancel Reservation'),
          showAlert: true
        }];
        const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
          popUpMessage[0].dialogTitle);
        this.cancelDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.cancellationChargeInfo, '450px', '300px', true, '', this.ts.instant('Yes'),
          this.ts.instant('No'), true)
      }
      else {
        this.confirmCancelReservation();
      }
    });
  }

  confirmCancelReservation() {
    this.rs.CancelReservation(this.ls.restaurantWidgetSettings$.value.RestaurantId, this.ls.editPartyData$.value.Id, this.ls.language).subscribe(data => {
      if (data.State == OperationResultState.Success) {
        this.rs.reservationConfirmationText = 'reservationCancellationConfirmationText';
        this.gs.setMessageState(this.ts.instant('reservationCancellationText'), 0);
        this.reservationCancelled = true;
      }
      else {
        if(data.ValidationMessages && data.ValidationMessages.length > 0){
          this.gs.setMessageState(data.ValidationMessages[0].Message, 0);
        }
      }
    });
  }

  cancelationInformation() {
    const datePipeString = this.dateFormat.transform(new Date(this.ls.editPartyData$.value.ReservedFor) , this.ls.restaurantWidgetSettings$.value.DateFormat);
    this.ts.get('cancelReservationConfirmation', { date: datePipeString, locationName: this.ls.restaurantWidgetSettings$.value.RestaurantName }).subscribe(text => {
      const popUpMessage = [{
        confirmationMessage: text,
        dialogTitle: this.ts.instant('reservationCancelTitle'),
        showAlert: true
      }];
      const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
        popUpMessage[0].dialogTitle);
      this.openCustomPopup(componentDetails, ComponentTypes.informationPopup, '450px', '300px', true, '', this.ts.instant('Ok'),
        '', false)

    });


  }

  bookReservation(eve) {
    this.resetPage(operationType.create);
  }

  resetPage(operation: operationType, reservationData?: ReservationDTO) {
    this.ls.operation = operation;
    this.rs.additionalGuestPage = false;
    this.ls.editPartyData = '';
    this.ls.operation == operationType.create ? this.ls.editPartyData$.next(null) : (!this.ls.editPartyData$.value && this.ls.editPartyData$.next(reservationData));
    this.rs.ispaymentInvolvedInfo = null;
    this.rs.reservationAttemptInfo = null;
    this.ls.nextButton.next(componentName.reservationDetails);
  }

  additionalGuest(eve) {
    this.ls.nextButton.next(componentName.guestDetails)
  }

  showTaxes(){
    this.showTaxDetails = !this.showTaxDetails;
  }
  
  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

}


@Pipe({
    name: 'coverTypePriceFilter',
    standalone: false
})
export class CoverTypePriceFilter implements PipeTransform {

  transform(selectedMeal: SpecialMealDTO, CoverType: CoverTypeQuantitiesDTO): any {
    let price = 0;
    let coverTypeSelected = selectedMeal.CoverTypePrices.filter(type => type.Id == CoverType.CoverTypeId)[0];
    if (coverTypeSelected) {
      price = coverTypeSelected.Price * CoverType.Covers
    }
    return price;
  }

}
